import React, { PropsWithChildren, useCallback } from "react";
import Link from "../../nav/Link/Link";
import * as SupportUtils from "../../../lib/util/SupportUtils";

export type SupportLinkProps = PropsWithChildren<{}>;

const SupportLink = (props: SupportLinkProps) => {
	const { children } = props;

	const handleSupport = useCallback((e: React.MouseEvent) => {
		if (!SupportUtils.isSupportDisabled()) {
			e.preventDefault();
			SupportUtils.contactSupport();
		}
	}, []);

	return (
		<Link href={SupportUtils.getSupportMailToLink()} onClick={handleSupport}>
			{children || SupportUtils.SUPPORT_EMAIL}
		</Link>
	);
};

export default React.memo(SupportLink);
